import { Icon } from "@mui/material";
import { UserPermissions } from "generated/graphql";
import AuthWall from "modules/AuthWall/AuthWall";
import AuthWallSubscriber from "modules/AuthWallSubscriber/AuthWallSubscriber";
import ViewJobPage from "pages/jobs/Job";
import JobCostPage from "pages/jobs/JobCostPage";
import JobPhasesListPage from "pages/jobs/JobPhasesListPage";
import JobWorkOrderPage from "pages/jobs/JobWorkOrderPage";
import JobsListPage from "pages/jobs/JobsListPage";
import DispatchPage from "pages/jobs/DispatchPage";
import JobsSchedulePage from "pages/jobs/JobsSchedulePage/JobsSchedulePage";
import JobsSchedulePageLegacy from "pages/jobs/JobsSchedulePageLegacy/JobsSchedulePageLegacy";
import WorkOrder from "pages/jobs/WorkOrder";
import InvoicesPage from "pages/organization/invoices";

const jobRoutes = [
  {
    type: "collapse",
    name: "Jobs",
    key: "jobs",
    icon: <Icon fontSize="medium">work</Icon>,
    permission: UserPermissions.VIEW_JOB_INFO,
    collapse: [
      {
        type: "link",
        name: "Jobs",
        key: "jobs.list",
        route: "/jobs",
        permission: UserPermissions.VIEW_JOB_INFO,
        component: (
          <AuthWall permission={UserPermissions.VIEW_JOB_INFO}>
            <AuthWallSubscriber>
              <JobsListPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "link",
        name: "Job Phases",
        key: "jobs.phases",
        route: "/job-phases",
        component: (
          <AuthWall>
            <AuthWallSubscriber>
              <JobPhasesListPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "link",
        name: "Invoices",
        key: "jobs.invoices",
        route: "/invoices",
        permission: UserPermissions.VIEW_JOB_INFO,
        component: (
          <AuthWall permission={UserPermissions.VIEW_JOB_INFO}>
            <AuthWallSubscriber>
              <InvoicesPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
    ],
  },
  {
    type: "link",
    name: "Schedule",
    key: "jobs.schedule",
    route: "/jobs/schedule",
    permission: UserPermissions.VIEW_SCHEDULE,
    icon: <Icon fontSize="medium">calendar_today</Icon>,
    component: (
      <AuthWall permission={UserPermissions.VIEW_SCHEDULE}>
        <AuthWallSubscriber>
          <JobsSchedulePage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "link",
    name: "Dispatch",
    key: "jobs.dispatch",
    route: "/jobs/dispatch",
    permission: UserPermissions.VIEW_SCHEDULE,
    icon: <Icon fontSize="medium">local_shipping</Icon>,
    component: (
      <AuthWall permission={UserPermissions.VIEW_SCHEDULE}>
        <AuthWallSubscriber>
          <DispatchPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Schedule (Classic)",
    key: "jobs.schedule.classic",
    route: "/jobs/schedule-classic",
    permission: UserPermissions.VIEW_SCHEDULE,
    component: (
      <AuthWall permission={UserPermissions.VIEW_SCHEDULE}>
        <AuthWallSubscriber>
          <JobsSchedulePageLegacy />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Job",
    key: "jobs.view",
    route: "/jobs/:jobId",
    permission: UserPermissions.VIEW_JOB_INFO,
    component: (
      <AuthWall permission={UserPermissions.VIEW_JOB_INFO}>
        <AuthWallSubscriber>
          <ViewJobPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Job Phase",
    key: "jobs.view.phase",
    route: "/jobs/:jobId/phases/:jobPhaseId",
    component: (
      <AuthWall>
        <AuthWallSubscriber>
          <JobCostPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Work Order",
    key: "jobs.view.workorder",
    route: "/jobs/:jobId/phases/:jobPhaseId/work-order",
    component: (
      <AuthWall permission={UserPermissions.VIEW_WORK_ORDER}>
        <AuthWallSubscriber>
          <WorkOrder />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Work Order",
    key: "jobs.full.view.workorder",
    route: "/jobs/:jobId/work-order",
    permission: UserPermissions.VIEW_WORK_ORDER,
    component: (
      <AuthWall permission={UserPermissions.VIEW_WORK_ORDER}>
        <AuthWallSubscriber>
          <JobWorkOrderPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
] as const;

export default jobRoutes;
